import { useContext, useState } from 'react';
import { cn } from '@/shared/styles/utils.ts';
import { AppContext } from '@/app/context';
import { Locales } from '@/app/locales/types.ts';

export const LangSwitcher = () => {
  const { locale, setLocale } = useContext(AppContext);
  const [translateValue, setTranslateValue] = useState<0 | 100>(() => {
    if (locale === Locales.RU) {
      return 0;
    }
    return 100;
  });

  const onClick = () => {
    setTranslateValue((prev) => {
      if (prev === 0) {
        return 100;
      }
      return 0;
    });

    setLocale();
  };

  return (
    <div className="bg-light-gray relative flex items-center rounded-sm">
      <div className="absolute top-0 right-0 bottom-0 left-0 z-1 overflow-hidden rounded-sm">
        <div
          style={{ transform: `translateX(${translateValue}%)` }}
          className="bg-brand absolute h-full w-[50%] rounded-sm transition-all"
        />
      </div>
      <button
        type="button"
        className="relative z-2 px-3 py-2"
        onClick={onClick}
      >
        <span
          className={cn(
            translateValue === 0
              ? 'text-light font-medium'
              : 'text-gray font-light'
          )}
        >
          рус
        </span>
      </button>
      <button
        type="button"
        className="relative z-2 px-3 py-2"
        onClick={onClick}
      >
        <span
          className={cn(
            translateValue === 0
              ? 'text-gray font-light'
              : 'text-light font-medium'
          )}
        >
          қаз
        </span>
      </button>
    </div>
  );
};
